module.exports = "/images/old.svg?568ce3d3b2fe8bb645096140ce074eca";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/images/old.svg
// module id = 88
// module chunks = 1